var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytics-tags-filter"},[_c('ds-multiselect',{attrs:{"multiple":"","searchable":"","placeholder":"Search tags","bind-value-only":"","options":_vm.availableTagOptions},model:{value:(_vm.filter.value),callback:function ($$v) {_vm.$set(_vm.filter, "value", $$v)},expression:"filter.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }